import { Outlet, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import authImage from "../asset/images/sample2.png";

export default function AuthLayout() {
    const imageSrc = authImage;
    const { pathname } = useLocation();
    const isAdmin = pathname.startsWith("/admin");
    const mobileTitle = isAdmin ? "Admin Portal" : "Dealer Portal";

    return (
        <div className="min-h-screen bg-[#f2eee7] w-full font-poppins flex items-center justify-center p-0 md:p-4">
            <div className="bg-white w-full max-w-[900px] rounded-none md:rounded-3xl shadow-none md:shadow-2xl flex flex-col md:flex-row overflow-hidden h-[100dvh] md:h-[85vh] items-stretch">
                {/* Mobile brand moment: same portal image, composed for a narrow screen. */}
                <div className="relative h-52 shrink-0 overflow-hidden bg-[#172438] md:hidden">
                    <img
                        src={imageSrc}
                        alt=""
                        aria-hidden="true"
                        className="absolute inset-0 h-full w-full object-cover object-[center_55%]"
                    />
                    <div className="absolute inset-0 bg-gradient-to-br from-[#172438]/80 via-[#172438]/45 to-[#8b6838]/75" />
                    <div className="absolute inset-0 flex items-start justify-between gap-4 p-5">
                        <img src="/logo.png" alt="Deco TV Frames" className="w-[122px] rounded-lg bg-white px-2 py-1.5 shadow-lg" />
                        <h2 className="pt-2 text-right text-lg font-bold leading-tight text-white drop-shadow-md">{mobileTitle}</h2>
                    </div>
                </div>

                {/* LEFT COLUMN: HERO IMAGE */}
                <div className="hidden md:block w-1/2 bg-gray-100 relative group overflow-hidden">
                    <img
                        src={imageSrc}
                        alt="Welcome"
                        className="w-full h-full object-cover absolute inset-0 transition-transform duration-700 group-hover:scale-105"
                    />

                    {/* Framer Motion Overlay */}
                    <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/20 to-transparent flex flex-col justify-start p-12 text-white">
                        <motion.div
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.8, delay: 0.2 }}
                        >
                            <h2 className="text-4xl font-bold mb-4 font-poppins">Dealer Portal</h2>
                            <p className="text-white text-lg font-medium drop-shadow-md leading-relaxed">
                                Manage your inventory, leads, and business growth all in one place.
                            </p>
                        </motion.div>
                    </div>
                </div>
                {/* RIGHT COLUMN: DYNAMIC CONTENT (Login/Register Forms) */}
                <div className="auth-mobile-form min-h-0 flex-1 w-full md:w-1/2 p-5 sm:p-8 md:p-8 flex flex-col bg-white relative overflow-y-auto">
                    <div className="auth-mobile-form-content flex min-h-0 flex-1 flex-col md:my-auto md:flex-initial">
                        <Outlet />
                    </div>
                </div>
            </div>
        </div>
    );
}
